<template>
    <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-menu
                                v-model="recognitionDateShow"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                                ref="menu"
                                max-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="recognitionDateDisplay"
                                        label="Data rozpoznania"
                                        prepend-icon="fa fa-calendar"
                                        readonly
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="recognitionDate" scrollable @input="closeDatePickerRecognition">
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="recognitionDateShow = false">Cancel</v-btn>
                                <v-btn text color="primary" @click="$refs.menu.save(recognitionDate)">OK</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-menu
                                v-model="curedDateShow"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                ref="menuCured"
                                min-width="290px"
                                max-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="curedDateDisplay"
                                        label="Data wyleczenia"
                                        prepend-icon="fa fa-calendar"
                                        readonly
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="curedDate" scrollable @input="closeDatePickerCured">
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="curedDateShow = false">Cancel</v-btn>
                                <v-btn text color="primary" @click="$refs.menuCured.save(curedDate)">OK</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-select label="Typ" item-text="description" item-value="id" :items="subtypes" v-model="subtype"></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-autocomplete
                                v-model="icd10"
                                id="icd10"
                                name="icd10"
                                :loading="isLoadingICD"
                                :items="icdList"
                                :search-input.sync="icdKeyword"
                                flat
                                no-data-text="Nieznaleziono"
                                hide-details
                                item-text="name"
                                item-value="id"
                                prepend-icon="fa-search"
                                label="Wyszukaj w ICD10"
                        >
                            <template v-slot:selection="data">
                                <v-sheet v-html="`${getHtmlDescription(data.item.kod,data.item.opis)}`"></v-sheet>
                            </template>
                            <template v-slot:item="data">
                                <v-sheet v-html="`${getHtmlDescription(data.item.kod,data.item.opis)}`"></v-sheet>
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea label="Dodatkowy opis"  v-model="description" name="description" id="description" rows="4"></v-textarea>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="save()" color="success">Zapisz</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="closeForm()" color="error">Zamknij</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import * as dayjs from "dayjs";
    import {icdService} from "../../services/icdService";
    import {clientService} from "../../services";
    import swal from "sweetalert";

    export default {
        name: "AddEditDisease",
        props: ["clientid","editedObject","subtypes"],
        data() {
            return {
                icd10: 0,
                description: null,
                isLoadingICD: false,
                icdList: [],
                icdKeyword: null,
                title: '',
                subtype: null,
                recognitionDateShow: false,
                recognitionDate: new Date().toISOString().substr(0, 10),
                recognitionDateDisplay: new dayjs().format('DD-MM-YYYY'),
                curedDate: null,
                curedDateDisplay: null,
                curedDateShow: false,

            }
        },
        methods: {
            closeForm() {
                this.$emit('close')
            },
            getHtmlDescription(kod,opis) {
              if(kod && opis)
              {
                  return '<span style="font-weight:bold">'+kod+'</span> - ' +opis
              }
              return ''
            },
            getICDValues(val)
            {
                if(this.isLoadingICD) return
                this.isLoadingICD = true
                icdService.getAll({query: val, page: 1, limit:20}).then(data => {
                    data.data.result.items.forEach(item => {

                        if (!this.icdList.find(x => x.id === item.id)) {
                            //let name = item.kod + ' ' + item.opis_icd

                            this.icdList.push({
                                id: item.id,
                                name: item.kod + ' ' +item.opis_icd,
                                kod: item.kod,
                                opis: item.opis_icd
                            });
                        }
                    })
                    this.isLoadingICD = false
                }).catch(() => {
                    this.isLoadingICD = false
                })
            },
            save()
            {
                if(!this.icd10 && !this.description)
                {
                    this.showError(false,'Nie podano kodu ICD ani opisu.')
                    return
                }
                if(!this.subtype)
                {
                    this.showError(false,'Nie wybrano typu.')
                    return
                }
                if(this.editedObject && this.editedObject.id > 0)
                {
                    clientService.updateClientDisease({description: this.description, icd10_Id: this.icd10, clientId: this.clientid, recognitionTime: this.recognitionDate, id: this.editedObject.id, curedTime: this.curedDate ,subtype: this.subtype}).then(()=> {
                        this.closeForm()
                    }).catch(() => {
                        this.showError(false, 'Błąd zapisu choroby')
                    })

                }
                else
                {
                    clientService.addClientDisease({description: this.description, icd10_Id: this.icd10, type: 0, clientId: this.clientid, recognitionTime: this.recognitionDate, curedTime: this.curedDate,subtype: this.subtype}).then(() => {
                        this.closeForm();
                    }).catch(() => {
                        this.showError(false, 'Błąd dodawania chorobyu')
                    })
                }
            },
            showError(close, text) {
                swal({
                    title: "Błąd",
                    text: text,
                    icon: "warning",
                    button: "OK"
                }).then(() => {
                    this.loading = false;
                    if (close) {
                        this.$emit("close");
                    }
                });
            },
            closeDatePickerRecognition()
            {
                this.recognitionDateShow = false
                let dj = dayjs(this.recognitionDate)
                this.recognitionDateDisplay = dj.format("DD-MM-YYYY")
            },
            closeDatePickerCured()
            {
                this.curedDateShow = false
                let dj = dayjs(this.curedDate)
                this.curedDateDisplay = dj.format("DD-MM-YYYY")
            }
        },
        watch: {
            icdKeyword(val) {
                if(val)
                {
                    this.getICDValues(val)
                }
            },
            editedObject: {
                immediate: true,
                handler(val) {
                    if(val != null)
                    {
                        this.description = val.description
                        let dj = dayjs(val.recognitionTime)
                        this.recognitionDate = dj.format("YYYY-MM-DD")
                        this.recognitionDateDisplay = dj.format("DD-MM-YYYY")
                        if(val.curedTime != null)
                        {
                            let djCured = dayjs(val.curedTime)
                            this.curedDate = djCured.format('YYYY-MM-DD')
                            this.curedDateDisplay = djCured.format('DD-MM-YYYY')
                        }
                        if(val.icd !== null)
                        {

                            this.icdList.push({
                                id: val.icd.id,
                                name: val.icd.kod + ' ' +val.icd.opis_icd,
                                kod: val.icd.kod,
                                opis: val.icd.opis_icd
                            })
                            this.icd10 = val.icd.id
                        }
                        this.subtype = val.subType;
                        this.title = 'Edytowanie choroby'
                    }
                    else
                    {
                        this.title = 'Dodawanie choroby'
                    }
                }
            }

        }
    }
</script>

<style scoped>

</style>